import cn from 'classnames'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Input } from 'core-components/library/inputs'
import { updateAssortmentGroup } from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentGroup } from 'partner360/features/assortment/models/data/IAssortmentGroup'

import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './GroupName.module.scss'

interface IGroupNameProps {
  isEditMode: boolean
  group: IAssortmentGroup
}

export const GroupName: FC<IGroupNameProps> = ({ isEditMode, group }) => {
  const dispatch = useAppDispatch()

  const changeGroupName = useCallback(
    (groupName: string) => {
      dispatch(
        updateAssortmentGroup({
          ...group,
          GroupName: groupName,
        })
      )
    },
    [dispatch, group]
  )

  if (isEditMode) {
    return (
      <div className={cn(styles.root, styles.editMode)}>
        <Input
          label={<Translation text={TRANSLATION_KEYS.group.groupNameLabel} />}
          value={group.GroupName}
          onChange={changeGroupName}
        />
      </div>
    )
  }

  return <div className={styles.root}>{group.GroupName}</div>
}
